import React from 'react'

export const AppContext = React.createContext({})
export const AuthContext = React.createContext({})
